const dateFormat = new Intl.DateTimeFormat('en-US', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
});

window.okeReviewsWidgetOnInit = function () {
    moveRatingDistribution();

    const reviewMain = document.querySelector('.js-okeReviews-reviews-main');
    if (reviewMain) {
        const dateObserver = new MutationObserver(formatDateForElement);
        dateObserver.observe(reviewMain, {childList: true});
        formatDateForElement();

        const config = {
            childList: true
        };
      
        const callback = function (mutationList) {
            for (const mutation of mutationList) {
                mutation.addedNodes.forEach((n) => moveReviewerBadge(n));
            }
        };
      
        const observer = new MutationObserver(callback, config);
        observer.observe(reviewMain, config);

        const reviews = document.querySelectorAll(".okeReviews-reviews-review");
        reviews.forEach((n) => moveReviewerBadge(n));
    }
};

function moveRatingDistribution() {
    const ratingDistribution = document.querySelector(".js-or-rtgDis");
  	const ratingDistributionHolder = document.querySelector(".okeReviews-ratingDistribution-holder");
    if(ratingDistribution && ratingDistributionHolder) {
      ratingDistributionHolder.insertAdjacentElement("beforeend", ratingDistribution);
    }
}

function moveReviewerBadge(nodeElement) {
	const reviewProfileDetails = nodeElement.querySelector(".okeReviews-review-reviewer-profile-details");
  	const reviewDate = nodeElement.querySelector(".okeReviews-review-date");
    if(reviewProfileDetails && reviewDate) {
        reviewProfileDetails.insertAdjacentElement("afterend", reviewDate);
    }
}

function formatDateForElement() {
    const reviewDates = document.querySelectorAll('[data-oke-reviews-date]');
    for (const reviewDate of reviewDates) {
        const dateIsoString = reviewDate.getAttribute('data-oke-reviews-date');
        const date = new Date(dateIsoString);
        const localeDate = `${dateFormat.format(date)}`;
        reviewDate.innerText = localeDate;
    }
}